<template>
  <div>
    <div class="headbt">
     测评任务
    </div>

   <!-- <div class=" top1 headcd">
    <div class="col-sm-4 col-4 col-md-4" :class="show_num==1?'shouye_active':''" @click="show_num=1">
    		进行中
    </div>
    <div class="col-sm-4 col-4 col-md-4"  :class="show_num==2?'shouye_active':''" @click="show_num=2">
    		已结束
    </div>
    <div class="col-sm-4 col-4 col-md-4"  :class="show_num==3?'shouye_active':''" @click="show_num=3">
    		全部
    </div>
  </div> -->
  <div class="rwgl" v-if="all_count== 0 && isShow == true">
    <img src="../../assets/img/zwsj.jpg"/>
  </div>
    <div class="rwgl" v-for="item in listdata">
      <div class="uinfo">
      	<div class="uinfo_1 ">

      	<ul class="list-group">

          <li class="list-group-item  userliebiao">

          	<div class=" col-sm-4 col-4 col-md-4 leftsj" >
          		任务名称
          	</div>
          	<div class=" col-sm-8 col-8 col-md-8 rwmc rightsj jxz" style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis;"  >
          		{{item.taskName}}
          	</div>
          </li>
          <li class="list-group-item  userliebiao">
          	<div class=" col-sm-3 col-3 col-md-3 leftsj" >
               开始时间
             </div>
            <div class=" col-sm-9 col-9 col-md-9 rightsj" >
              {{item.startTime}}
             </div>
          </li>
      	<li class="list-group-item  userliebiao">
      		<div class=" col-sm-3 col-3 col-md-3 leftsj" >
      	     结束时间
      	   </div>
      	  <div class=" col-sm-9 col-9 col-md-9 rightsj" >
           {{item.endTime}}
      	   </div>
      	</li>
        <li class="list-group-item  userliebiao">
        	<div class=" col-sm-3 col-3 col-md-3 leftsj" >
             任务状态
           </div>
          <div class=" col-sm-9 col-9 col-md-9 rightsj jxz" v-if="item.taskStatus == '进行中'" >
            {{item.taskStatus}}
           </div>
           <div class=" col-sm-9 col-9 col-md-9 rightsj jiahong" v-if="item.taskStatus == '已结束'" >
             {{item.taskStatus}}
            </div>
            <div class=" col-sm-9 col-9 col-md-9 rightsj jiahong" v-if="item.taskStatus == '未开始'" >
              {{item.taskStatus}}
             </div>
        </li>
        <li class="list-group-item  userliebiao">
        	<div class=" col-sm-3 col-3 col-md-3 leftsj" >
             测评状态
           </div>
          <div class=" col-sm-9 col-9 col-md-9 rightsj " v-if="item.evaluationStatus =='已测'" >
            {{item.evaluationStatus}}
           </div>
           <div class=" col-sm-9 col-9 col-md-9 rightsj " v-else-if="item.evaluationStatus =='未测'" >
             {{item.evaluationStatus}}
            </div>
            <div class=" col-sm-9 col-9 col-md-9 rightsj " v-else >
              {{item.evaluationStatus}}
             </div>
        </li>
      <li class="list-group-item  rwlast" @click="rwxq(item)">
      		<div class="qrbc">查看详情</div>
      	</li>

      	</ul>
      	</div>
      </div>
    </div>
    <div class="jzxyy">
      <div class="djjzxyy" @click="xym"  v-if="xyy == 1 && all_count > 0">
          点击加载下一页
      </div>
      <div class="djjzxyy"  v-if="xyy == 0 && all_count > 0">
          没有更多数据
      </div>

    </div>

    <div class="jbk">

    </div>
   <!-- <div class="fixed-right" @click="tz('/user/kefu')">
     <img src="../../assets/img/zxzx.png" >
     <br>
     在线咨询
   </div> -->
    <div class="footer">
		  <div class="item_list_menu col-sm-3 col-3 col-md-3"  @click="tz('/base/index')">
			  <div class="dibumenu">
          	 <img src="../../assets/img/home.png" >
			</div>
			  <div class="xmtitle ">
			  	首页
			  </div>
		  </div>
			<div class="item_list_menu col-sm-3 col-3 col-md-3"  >
				<div class="dibumenu">

             <img src="../../assets/img/cp_xz.png" >
				</div>
				<div class="xmtitle xmtitle_active">
					测评任务
				</div>
			</div>
			<div class="item_list_menu col-sm-3 col-3 col-md-3"  @click="tz('/user/wdcp')">
				<div class="dibumenu">
				 	 <img src="../../assets/img/wdcp.png" >
				</div>
				<div class="xmtitle ">
					我的测评
				</div>
			</div>
			<div class="item_list_menu col-sm-3 col-3 col-md-3" @click="tz('/user/index')">
				<div class="dibumenu">
					 <img src="../../assets/img/wd.png" >
				</div>
				<div class="xmtitle ">
					我的
				</div>
			</div>
		</div>
  </div>
</template>

<script>
import {cprwdata} from '../../api/baseset'

  export default {
      data() {
        return {
          show_num:1,
           formInline: {
             page: 1,
             limit: 10
           },
           page:1,
           limit:10,
           listdata:[],
           all_count:0,
           xyy:0,
          isShow:false
        }
      },
      mounted() {
        this.getdata();
     // this.getsjtjs();
      },
      methods: {

        getdata(){

          this.loading = true
          let param={pageNum:this.page,pageSize:this.limit}
            cprwdata(param)
             .then(res => {

               this.loading = false
               if (res.code != 200) {
                 this.$message({
                   type: 'info',
                   message: res.msg
                 })
               } else {

                  this.listdata = this.listdata.concat(res.data);
                  this.all_count = res.total
                  if(this.limit*this.page < this.all_count){
                    this.xyy = 1;
                  }else{
                    this.xyy = 0;
                  }
               }
               this.isShow = true
             })
             .catch(err => {
               this.loading = false
               this.$message.error('数据加载失败，请稍后再试！')
             })

        },

        // 搜索事件
        xym() {
          this.page = this.page+1;
          this.getdata()
        },
        // 重置搜索
        formReset() {
          this.formInline.key = '';
        },
        shouli() {

        },
        chuli() {
          this.dialogVisible = true;
        },
        rwxq(row){

          localStorage.setItem('rw_data', JSON.stringify({
            title: row.taskName,
            //rwzt:"已结束",
             rwzt:row.taskStatus,
            start_time:row.startTime,
            end_time:row.endTime,
            rwid:row.id,

           // kszt:row.
          /* 其他数据 */
          }))
          this.$router.push("/user/rwxq/"+row.id);
        },
        tz(url){

          this.$router.push(url);
        },
      }
    }
  </script>

<style scoped>
  	body{
  			background-color: #EFEFF4;
  		}


  		.footer {
  		  position: fixed ;
  		  bottom: 0;
  		  width: 100%;
  		  height: 60px;

  		  background-color: white;
  		  display: flex;
  		  border-top: solid 1px #E6EAEC;

        margin-left:  0 !important;
  		}
  		.item_list_menu{
  			/* border: solid 1px red; */
  			text-align: center;
  		}
  		.dibumenu{
  			width: 100%;
  			text-align: center;
  			padding-top: 3px;
  		}
  		.dibumenu img{
  			width: 24px;
  			height: 24px;
  		}
  		.xmtitle{
  			text-align: center;
  			font-size: 12px;
  			color: #666666;
  		}
  		.xmtitle_active{
  			color: #00DDA3;
  		}

      .shouye_active{
        color: #00DDA3;
        border-bottom: solid 2px #00DDA3;
      }
      .headcd{
      			height: 40px;
      			line-height: 40px;
      			width: 100%;
      			background-color: white;
      			text-align: center;
      			display: flex;
            font-size: 16px;
      		}
      		.xz{
      			width: 100%;
      		}
    .rwgl{
      width: 100%;
      height: auto;
      /* padding-top: 10px;
      padding-bottom: 10px;
      border: solid 1px red; */
      margin-top: 15px;
    }
    .border{
    	border-bottom: 1px #3CB9F3 solid;
    	color:#3CB9F3 !important;
    }
    .order_list{
    	width: 100%;
    	height: auto;

    	background-color: white;
    	margin-top: 12px;
    }
    .order_list_u{
    	margin-top: 5px;

    }
    .order_time{
      height: 40px;
    	border:none !important;
    	border-bottom: solid 1px #ccc !important ;
    }
    .order_time_1{
    	width: 100%;height: 40px;line-height: 40px;
    }
    .order_time_2{
    	font-size: 12px;
    }
    .order_time_status{
    	color: red;font-size: 14px;float: right;
    }
    .order_time_shop{
    	height: 10rem;
    }
    .order_shop_info{

    	padding-left: 0px !important;
    	padding-right: 0px !important;

    }
    .anniu{
    	width: 30%;
      height: 35px;
      line-height: 35px;
      text-align: center;
      color: white;
      background-color: #00DDA3;
      border-radius: 5px 5px 5px 5px ;
      box-shadow: #ccc;
      float: right;
    }
    .userliebiao{
    	display: flex;
    	font-size: 14px;
    	height: auto;
    	padding-top: 5px;
    	padding-bottom: 5px;
    	background-color: white;

    }
    .userinfo{
    	text-align: right;
    }
    .form-control{
    	 border: none !important;
    	font-size: 14px;
    	height: 3rem;

    }
    .form-control:focus {
        outline: none;
        border-color: #ccc;
        border: none;
        -webkit-box-shadow: none;
        box-shadow: none;
    }

    .xingxing{
    	color:red;
    }
    .list-group{
    	--bs-list-group-border-radius:0 0 0 0 !important;
    }

    .list-group-item{
    	border-radius: 0 0 0 0 ;
    	border: none !important;
    	padding:  0 0 0 0 !important;

    	height: 3rem;
    	line-height:3rem;
    	font-size: 14px;
    	color: #666666;
    	border-bottom: solid  1px #E6EAEC !important;
    }
    .list-group-item:first-child{
    	border-top-left-radius: 0;
    	border-top-right-radius: 0;

    }
    .item_list_menu{
    	/* border: solid 1px red; */
    	text-align: center;
    }

    .list-group{
    	--bs-list-group-border-radius:0 0 0 0 !important;
    }

    .list-group-item{
    	border-radius: 0 0 0 0 ;
    	border: none !important;
    	padding:  0 0 0 0 !important;

    	height: 3rem;
    	line-height:3rem;
    	font-size: 14px;
    	color: #666666;
    	border-bottom: solid  1px #E6EAEC !important;
    }
    .list-group-item:first-child{
    	border-top-left-radius: 0;
    	border-top-right-radius: 0;

    }
    .item_list_menu{
    	/* border: solid 1px red; */
    	text-align: center;
    }

    .userinfo{
    	text-align: right;
    }
    .dibuxian{
    	width: 100%;
    	height: 90px;
    }
    .yjt img{
    	width: 24px;
    	height: 24px;
    }

    .bfwrxx_left{
    	text-align: left !important;
    	font-size: 18px  !important;
    	line-height: 40px !important;

    }
    .qrbc{
    	width:40%;
    	height: 30px;
    	/* margin: 0 auto; */
    	text-align: center;
    	line-height: 30px;
    	color: white;
    	border-radius: 5px 5px 5px 5px;
    	background-color: #00DDA3;
    	margin-top: 15px;
    	margin-bottom: 15px;
      float: right;
    }
    .uinfo{
    	width: 94%;
      margin:  0 auto;
    	height: auto;
    	padding-top: 5px;
    	padding-bottom: 5px;
    	background-color: white;
      box-shadow: 5px 5px 5px 5px #ccc;
      border-radius: 5px 5px 5px 5px;
    }
    .uinfo_1{
    	width: 90%;
    	height: auto;
    	margin: 0 auto;

    }
    .bkx{
      width: 100%;
      height: 80px;
    }
    .list-group{
    	--bs-list-group-border-radius:0 0 0 0 !important;
    }

    .list-group-item{
    	border-radius: 0 0 0 0 ;
    	border: none !important;
    	padding:  0 0 0 0 !important;

    	height: 3rem;
    	line-height:3rem;
    	font-size: 14px;
    	color: #666666;
    	border-bottom: solid  1px #E6EAEC !important;
    }
    .list-group-item:first-child{
    	border-top-left-radius: 0;
    	border-top-right-radius: 0;

    }

    .userliebiao{
    	display: flex;
    	font-size: 14px;
    	height: auto;
    	padding-top: 5px;
    	padding-bottom: 5px;
    	background-color: white;

    }
    .userinfo{
    	text-align: right;
    }
    .form-control{
    	 border: none !important;
    	font-size: 14px;
    	height: 3rem;

    }
    .form-control:focus {
        outline: none;
        border-color: #ccc;
        border: none;
        -webkit-box-shadow: none;
        box-shadow: none;
    }

    .xingxing{
    	color:red;
    }
.rwmc{

  font-weight: bold;
  color: balck;
}
.leftsj{

  text-align: left;
}
.rightsj{

  text-align: right;
}

.ygq {
  position: absolute;
  width: 90%; /* 或者你需要的宽度 */
  height: 60px; /* 或者你需要的高度 */
  border: solid 1px red;

  z-index: 999;
  /* 其他样式 */
}
.ygqa img{
  width: 64px;
  height: 45px;
  float: right;
}
.jxz{
  color: #00DDA3;
  font-weight: bold;
}
.rwlast{
  border-bottom: none !important;
  text-align: right;height: 50px;
}

</style>



// WEBPACK FOOTER //
// src/views/user/cprw.vue